export default "__VITE_ASSET__lZJmulGt__"